import {
  ApplicationRef,
  ComponentRef,
  Directive,
  ElementRef,
  EnvironmentInjector,
  HostListener,
  Inject,
  Input,
  createComponent
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TooltipComponent } from './tooltip.component';

@Directive({
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  selector: '[appTooltip]'
})
export class TooltipDirective {
  @Input() tooltipText = '';

  private tooltipComponent?: ComponentRef<TooltipComponent>;

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private environmentInjector: EnvironmentInjector,
    private appRef: ApplicationRef,
    @Inject(DOCUMENT) private document: Document
  ) {}

  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event: MouseEvent): void {
    if (this.tooltipComponent || !this.isTextOverflowing()) {
      return;
    }

    this.tooltipComponent = createComponent(TooltipComponent, {
      environmentInjector: this.environmentInjector
    });

    this.appRef.attachView(this.tooltipComponent.hostView);
    this.document.body.appendChild(
      this.tooltipComponent.location.nativeElement
    );

    this.setTooltipComponentProperties(event);
    this.tooltipComponent.hostView.detectChanges();
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    if (this.tooltipComponent) {
      this.appRef.detachView(this.tooltipComponent.hostView);
      this.tooltipComponent.destroy();
      this.tooltipComponent = undefined;
    }
  }

  private setTooltipComponentProperties(event: MouseEvent): void {
    if (this.tooltipComponent) {
      this.tooltipComponent.instance.text = this.tooltipText;
      this.tooltipComponent.instance.left = event.clientX + 10;
      this.tooltipComponent.instance.top = event.clientY + 10;
    }
  }

  private isTextOverflowing(): boolean {
    const element = this.elementRef.nativeElement;
    return element.scrollWidth > element.clientWidth;
  }
}
